import { AppSseEvent } from "@elation/api-client/src/stitch-web";
import type {
  PatientSyncJobMetadataProgress,
  PatientSyncJobPhase,
} from "@elation/api-client/src/stitch-web/models";
import mitt from "mitt";

/**
 * Payloads for events on the local `appBus`. Encounter SSE types mirror the
 * server so {@link useAppSSEEvents} can forward each frame with
 * `appBus.emit(event, data)` without translation. `client.*` entries are
 * emitted from the UI (e.g. patient layout) for routing-driven store updates.
 */
export type AppBusEvents = {
  [K in AppSseEvent["type"]]: Extract<AppSseEvent, { type: K }>;
} & {
  "physician.patient_sync_started": { jobId: string; physicianId: number };
  "physician.patient_sync_progress": {
    jobId: string;
    phase: PatientSyncJobPhase;
    progress: PatientSyncJobMetadataProgress;
    physicianId: number;
  };
  "physician.patient_sync_succeeded": { jobId: string; physicianId: number };
  "physician.patient_sync_failed": {
    jobId: string;
    error: string;
    physicianId: number;
  };
  "sse.fallback-polling": { isFallbackPolling: boolean };
  "client.router_params_changed": {
    params: Record<string, string | undefined>;
  };
  "client.router_search_params_changed": { searchParams: URLSearchParams };
};

export const appBus = mitt<AppBusEvents>();
